import { Styles, css, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  root: () => css`
    z-index: 1300;
  `,
  content: () => css`
    width: 100%;
    max-width: 480px;
  `,
} satisfies Styles<{}>;

export const useStyles = withStyles(styles);
